// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"5af76408fa9dbfbfbcc4","678":"fae1759f5e12eafe43cc","883":"4e0480157606d4dcd26e","954":"9b0aff20ba7662a7137b"}[chunkId] + ".js";
};